<template>
  <div>
    <h1>Login</h1>

    <b-form @submit.stop.prevent="submit">
      <b-form-group id="form-email-group" label="Email addres:" label-for="form-text-email">
        <b-input
          type="email"
          id="form-text-email"
          required
          placeholder="email address"
          v-model="email"
        ></b-input>
      </b-form-group>

      <b-form-group id="form-password-group" label="Password:" label-for="form-text-password">
        <b-input type="password" id="form-text-password" required v-model="password"></b-input>
      </b-form-group>

      <b-button type="submit" variant="primary">Log in</b-button>
    </b-form>
    <b-alert :show="!!error" variant="warning">{{error}}</b-alert>
    <p>
      If you need to, please
      <router-link to="register">register</router-link>
    </p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import fb from "@/firebaseConfig";
export default {
  data() {
    return {
      email: "",
      password: "",
      error: ""
    };
  },
  methods: {
    async submit() {
      fb.auth
        .signInWithEmailAndPassword(this.email, this.password)
        .then(() => this.$router.replace({ name: "assets" }))
        .catch(err => {
          if (err) {
            console.log(err);
          }
        });
    }
  },
  computed: {
    ...mapGetters({ user: "user/user" })
  },
  watch: {
    "user.loggedIn": {
      immediate: true,
      handler: function(loggedIn) {
        if (loggedIn) {
          this.$router.replace({ name: "profile" });
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>